

import { useState, useEffect } from "react";
import "./Walletsidebar.css";
import { FaWallet, FaPlus, FaHistory, FaRupeeSign, FaCalendarAlt, FaClock, FaTimes, FaArrowRight, FaSpinner, FaGift, FaBuilding, FaUser, FaMobileAlt } from "react-icons/fa";
import axios from "axios";

const Payment = () => {
  const [showPopup, setShowPopup] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [amount, setAmount] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [transactions, setTransactions] = useState([]);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [selectedTransaction, setSelectedTransaction] = useState(null);
  const [isProcessing, setIsProcessing] = useState(false);
  const [userProfile, setUserProfile] = useState(null);
  const [wallet, setWallet] = useState({
    totalBalance: 0,
    cashbackAmount: 0,
    companyLoadedAmount: 0,
    selfLoadedAmount: 0,
    postPaidUsage: 0,
  });

  // Detect screen size
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Fetch wallet data
  useEffect(() => {
    const userId = localStorage.getItem("userId");
    const token = localStorage.getItem("authToken");

    if (!userId) return;

    const fetchWallet = async () => {
      try {
        const response = await axios.get(
          `https://backend.maamaas.com/subscription/api/user/wallet/${userId}`,
          {
            headers: token ? { Authorization: `Bearer ${token}` } : {},
          }
        );
        setWallet(response.data);
      } catch (error) {
        console.error("Error fetching wallet data:", error);
      }
    };

    fetchWallet();
  }, []);

  // Fetch user profile
  useEffect(() => {
    const fetchUserProfile = async () => {
      try {
        const userId = localStorage.getItem("userId");
        const token = localStorage.getItem("authToken");

        if (!userId || !token) return;

        const response = await axios.get(
          `https://backend.maamaas.com/subscription/api/user/getprofile/${userId}`,
          {
            headers: {
              accept: "*/*",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        setUserProfile(response.data);
      } catch (error) {
        console.error("Failed to fetch user profile", error);
      }
    };

    fetchUserProfile();
  }, []);

  // Fetch transactions
  useEffect(() => {
    const userId = localStorage.getItem("userId");
    const token = localStorage.getItem("authToken");

    if (!userId) return;

    axios
      .get(
        `https://backend.maamaas.com/subscription/api/user/wallet/transactions/${userId}`,
        {
          headers: token ? { Authorization: `Bearer ${token}` } : {},
        }
      )
      .then((res) => {
        const data = res.data || [];
        setTransactions(data);
      })
      .catch((err) => {
        console.error("Error fetching transactions:", err);
      });
  }, []);

  const loadRazorpayScript = () => {
    return new Promise((resolve) => {
      if (window.Razorpay) {
        resolve(true);
        return;
      }
      const script = document.createElement("script");
      script.src = "https://checkout.razorpay.com/v1/checkout.js";
      script.onload = () => resolve(true);
      script.onerror = () => resolve(false);
      document.body.appendChild(script);
    });
  };




  const handleSubmit = async () => {

    const userId = localStorage.getItem("userId");
    const token = localStorage.getItem("authToken");

    if (!userId || !amount) {
      alert("Please fill all fields");
      return;
    }

    setIsProcessing(true);

    try {

      // ==============================
      // LOAD RAZORPAY SDK
      // ==============================
      const res = await loadRazorpayScript();

      if (!res) {
        alert("Razorpay SDK failed to load");
        setIsProcessing(false);
        return;
      }

      // ==============================
      // RAZORPAY OPTIONS
      // ==============================
      const options = {

        key: "rzp_live_RU5whSMu9rPV7s",

        amount: Number(amount) * 100,

        currency: "INR",

        name: "Maamaa's House",

        description: "Wallet Load",

        prefill: {
          name: userProfile?.userName || "User",
          email: userProfile?.emailId || "",
          contact: userProfile?.mobileNumber || "",
        },

        theme: {
          color: "#3399cc",
        },

        // ==============================
        // PAYMENT SUCCESS
        // ==============================
        handler: async function (response) {

          console.log(
            "✅ Razorpay Success Response:",
            response
          );

          try {

            const payload = {
              userId: userId,
              amount: amount,
              paymentId: response.razorpay_payment_id,
              orderId:
                response.razorpay_order_id ||
                "ORDER_" + Date.now(),
            };

            console.log("📦 API PAYLOAD:", payload);

            // ==============================
            // ADD CASH API
            // ==============================
            const result = await axios.post(
              "https://backend.maamaas.com/subscription/api/user/addCash/self-loaded",
              {},
              {
                params: payload,

                headers: {
                  Authorization: `Bearer ${token}`,
                  "Content-Type": "application/json",
                  accept: "*/*",
                },
              }
            );

            console.log(
              "✅ Wallet Loaded Response:",
              result.data
            );

            // ==============================
            // SUCCESS
            // ==============================
            if (result.status === 200) {

              alert(`₹${amount} added successfully to wallet`);

              try {

                const walletResponse = await axios.get(
                  `https://backend.maamaas.com/subscription/api/user/wallet/${userId}`,
                  {
                    headers: {
                      Authorization: `Bearer ${token}`,
                    },
                  }
                );

                setWallet(walletResponse.data);

                const transactionResponse = await axios.get(
                  `https://backend.maamaas.com/subscription/api/user/wallet/transactions/${userId}`,
                  {
                    headers: {
                      Authorization: `Bearer ${token}`,
                    },
                  }
                );

                setTransactions(transactionResponse.data || []);

              } catch (walletErr) {

                console.error(
                  "Wallet refresh issue:",
                  walletErr
                );

                // ❌ NO ALERT HERE
              }

              handleClose();

            }
          } catch (err) {

            console.error(
              "❌ Wallet API Error:",
              err
            );

            // FULL ERROR DEBUG
            if (err.response) {

              console.log(
                "STATUS:",
                err.response.status
              );

              console.log(
                "DATA:",
                err.response.data
              );
            }

            alert(
              err?.response?.data?.message ||
              "Wallet load failed on server"
            );
          } finally {

            setIsProcessing(false);
          }
        },

        modal: {
          ondismiss: function () {
            setIsProcessing(false);
          },
        },
      };

      // ==============================
      // OPEN RAZORPAY
      // ==============================
      const rzp = new window.Razorpay(options);

      rzp.open();

    } catch (error) {

      console.error("❌ PAYMENT ERROR:", error);

      setIsProcessing(false);

      alert("Payment initialization failed");
    }
  };
  // Helper function to complete payment success
  const completePaymentSuccess = async (paymentId, orderId, amount, userId, token) => {
    try {
      const addCashResponse = await axios.post(
        `https://backend.maamaas.com/subscription/api/user/addCash/self-loaded`,
        {},
        {
          params: {
            userId: userId,
            amount: amount,
            paymentId: paymentId,
            orderId: orderId
          },
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json"
          },
        }
      );

      if (addCashResponse.data.success || addCashResponse.status === 200) {
        alert(`Successfully added ₹${amount} to your wallet!`);

        handleClose();
      } else {
        alert(`Payment verified but failed to add funds. Payment ID: ${paymentId}. Please contact support.`);
      }
    } catch (error) {
      console.error("Error adding cash:", error);
      alert(`Payment verified but failed to add funds. Payment ID: ${paymentId}. Please contact support.`);
    } finally {
      setIsProcessing(false);
    }
  };

  // Helper function to refresh wallet data
  const refreshWalletData = async (userId, token) => {
    try {
      const walletResponse = await axios.get(
        `https://backend.maamaas.com/subscription/api/user/wallet/${userId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
          timeout: 5000
        }
      );
      setWallet(walletResponse.data);

      const transactionsResponse = await axios.get(
        `https://backend.maamaas.com/subscription/api/user/wallet/transactions/${userId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
          timeout: 5000
        }
      );
      setTransactions(transactionsResponse.data || []);

      return true;
    } catch (error) {
      console.error("Error refreshing wallet data:", error);
      return false;
    }
  };
  const handleOpen = () => setShowPopup(true);
  const handleClose = () => {
    setShowPopup(false);
    setAmount("");
    setIsProcessing(false);
  };

  const openTransactionDetails = (transaction) => {
    setSelectedTransaction(transaction);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedTransaction(null);
  };

  // Pagination
  const rowsPerPage = isMobile ? 5 : 10;
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const sortedTransactions = [...transactions].sort(
    (a, b) => new Date(b.transactionTime) - new Date(a.transactionTime)
  );
  const currentTransactions = sortedTransactions.slice(indexOfFirstRow, indexOfLastRow);
  const totalPages = Math.ceil(transactions.length / rowsPerPage);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-IN', {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    });
  };

  const formatTime = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleTimeString('en-IN', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    });
  };

  const walletCards = [
    { id: 1, title: "Total Balance", amount: wallet.totalBalance, icon: "💰", color: "total", key: "totalBalance" },
    { id: 2, title: "Cashback", amount: wallet.cashbackAmount, icon: "🎁", color: "cashback", key: "cashbackAmount" },
    { id: 3, title: "Company Loaded", amount: wallet.companyLoadedAmount, icon: "🏢", color: "company", key: "companyLoadedAmount" },
    { id: 4, title: "Self Loaded", amount: wallet.selfLoadedAmount, icon: "👤", color: "self", key: "selfLoadedAmount" },
    { id: 5, title: "Post Paid", amount: wallet.postPaidUsage, icon: "📱", color: "post", key: "postPaidUsage" },
  ];

  return (
    <div className="walletmaster-container">
      <div className="walletmaster-wrapper">
        {/* Header Section */}
        <div className="walletmaster-header">
          <div className="walletmaster-header-content">
            <div className="walletmaster-header-icon">
              <FaWallet />
            </div>
            <div className="walletmaster-header-text">
              <h1 className="walletmaster-header-title">My Wallet</h1>
              <p className="walletmaster-header-subtitle">Manage your funds & transactions</p>
            </div>
          </div>
        </div>

        {/* Wallet Cards Grid */}
        <div className="walletmaster-cards-grid">
          {walletCards.map((card) => (
            <div key={card.id} className={`walletmaster-card walletmaster-card-${card.color}`}>
              <div className="walletmaster-card-icon">{card.icon}</div>
              <div className="walletmaster-card-info">
                <h3 className="walletmaster-card-title">{card.title}</h3>
                <p className="walletmaster-card-amount">₹{card.amount}</p>
              </div>
            </div>
          ))}

          {/* Add Money Card */}
          <div className="walletmaster-card walletmaster-card-add">
            <button className="walletmaster-add-btn" onClick={handleOpen} disabled={isProcessing}>
              <FaPlus className="walletmaster-add-icon" />
              <span>Add Money</span>
            </button>
          </div>
        </div>

        {/* Transactions Section */}
        <div className="walletmaster-transactions">
          <div className="walletmaster-transactions-header">
            <div className="walletmaster-transactions-title">
              <FaHistory />
              <h2>Transaction History</h2>
            </div>
          </div>

          {isMobile ? (
            /* Mobile View - Column Layout */
            <div className="walletmaster-mobile-list">
              {currentTransactions.length > 0 ? (
                currentTransactions.map((transaction, index) => (
                  <div
                    key={transaction.id || index}
                    className="walletmaster-mobile-card"
                    onClick={() => openTransactionDetails(transaction)}
                  >
                    <div className="walletmaster-mobile-card-header">
                      <div className="walletmaster-mobile-type">
                        <span className={`walletmaster-mobile-badge ${transaction.transactionType === 'CREDIT' ? 'walletmaster-badge-credit' : 'walletmaster-badge-debit'}`}>
                          {transaction.transactionType}
                        </span>
                      </div>
                      <div className={`walletmaster-mobile-amount ${transaction.transactionType === 'CREDIT' ? 'walletmaster-amount-credit' : 'walletmaster-amount-debit'}`}>
                        {transaction.transactionType === 'CREDIT' ? '+' : '-'}₹{transaction.amount}
                      </div>
                    </div>
                    <div className="walletmaster-mobile-card-body">
                      <div className="walletmaster-mobile-row">
                        <span className="walletmaster-mobile-label">Balance Type:</span>
                        <span className="walletmaster-mobile-value">{transaction.balanceType}</span>
                      </div>
                      <div className="walletmaster-mobile-row">
                        <span className="walletmaster-mobile-label">Date:</span>
                        <span className="walletmaster-mobile-value">
                          <FaCalendarAlt /> {formatDate(transaction.transactionTime)}
                        </span>
                      </div>
                      <div className="walletmaster-mobile-row">
                        <span className="walletmaster-mobile-label">Time:</span>
                        <span className="walletmaster-mobile-value">
                          <FaClock /> {formatTime(transaction.transactionTime)}
                        </span>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div className="walletmaster-empty-state">
                  <div className="walletmaster-empty-icon">📊</div>
                  <h3>No Transactions Found</h3>
                  <p>Your transaction history will appear here</p>
                </div>
              )}
            </div>
          ) : (
            /* Desktop View - Table Layout */
            <div className="walletmaster-table-wrapper">
              <table className="walletmaster-table">
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Date & Time</th>
                    <th>Transaction Type</th>
                    <th>Amount</th>
                    <th>Balance Type</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {currentTransactions.map((transaction, index) => (
                    <tr key={transaction.id || index}>
                      <td>{indexOfFirstRow + index + 1}</td>
                      <td>
                        <div className="walletmaster-datetime">
                          <div><FaCalendarAlt /> {formatDate(transaction.transactionTime)}</div>
                          <div className="walletmaster-time"><FaClock /> {formatTime(transaction.transactionTime)}</div>
                        </div>
                      </td>
                      <td>
                        <span className={`walletmaster-type-badge ${transaction.transactionType === 'CREDIT' ? 'walletmaster-badge-credit' : 'walletmaster-badge-debit'}`}>
                          {transaction.transactionType}
                        </span>
                      </td>
                      <td className={transaction.transactionType === 'CREDIT' ? 'walletmaster-credit-text' : 'walletmaster-debit-text'}>
                        {transaction.transactionType === 'CREDIT' ? '+' : '-'}₹{transaction.amount}
                      </td>
                      <td>{transaction.balanceType}</td>
                      <td>
                        <button className="walletmaster-view-btn" onClick={() => openTransactionDetails(transaction)}>
                          View Details
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          {/* Pagination */}
          {transactions.length > rowsPerPage && (
            <div className="walletmaster-pagination">
              <button
                onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                disabled={currentPage === 1}
                className="walletmaster-page-btn"
              >
                Previous
              </button>
              <span className="walletmaster-page-info">Page {currentPage} of {totalPages}</span>
              <button
                onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                disabled={currentPage === totalPages}
                className="walletmaster-page-btn"
              >
                Next
              </button>
            </div>
          )}
        </div>

        {/* Add Money Modal */}
        {showPopup && (
          <div className="walletmaster-modal-overlay" onClick={handleClose}>
            <div className="walletmaster-modal" onClick={(e) => e.stopPropagation()}>
              <div className="walletmaster-modal-header">
                <h2>Add Money to Wallet</h2>
                <button className="walletmaster-modal-close" onClick={handleClose}>
                  <FaTimes />
                </button>
              </div>
              <div className="walletmaster-modal-body">
                <div className="walletmaster-input-group">
                  <label>Enter Amount (Min ₹1)</label>
                  <div className="walletmaster-input-wrapper">
                    <FaRupeeSign className="walletmaster-input-icon" />
                    <input
                      type="number"
                      placeholder="Enter amount"
                      value={amount}
                      onChange={(e) => setAmount(e.target.value)}
                      min="1"
                      step="1"
                      disabled={isProcessing}
                    />
                  </div>
                </div>
                <div className="walletmaster-quick-amounts">
                  <span>Quick Select:</span>
                  <div className="walletmaster-quick-buttons">
                    {[100, 200, 500, 1000, 2000].map(quickAmount => (
                      <button
                        key={quickAmount}
                        className="walletmaster-quick-btn"
                        onClick={() => setAmount(quickAmount.toString())}
                        disabled={isProcessing}
                      >
                        ₹{quickAmount}
                      </button>
                    ))}
                  </div>
                </div>
              </div>
              <div className="walletmaster-modal-footer">
                <button
                  className="walletmaster-submit-btn"
                  onClick={handleSubmit}
                  disabled={!amount || amount < 1 || isProcessing}
                >
                  {isProcessing ? <FaSpinner className="walletmaster-spinner" /> : "Proceed to Pay"}
                  {!isProcessing && <FaArrowRight />}
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Transaction Details Modal */}
        {isModalOpen && selectedTransaction && (
          <div className="walletmaster-modal-overlay" onClick={closeModal}>
            <div className="walletmaster-modal" onClick={(e) => e.stopPropagation()}>
              <div className="walletmaster-modal-header">
                <h2>Transaction Details</h2>
                <button className="walletmaster-modal-close" onClick={closeModal}>
                  <FaTimes />
                </button>
              </div>
              <div className="walletmaster-modal-body">
                <div className="walletmaster-detail-item">
                  <span className="walletmaster-detail-label">Transaction ID:</span>
                  <span className="walletmaster-detail-value">{selectedTransaction.id || 'N/A'}</span>
                </div>
                <div className="walletmaster-detail-item">
                  <span className="walletmaster-detail-label">Type:</span>
                  <span className={`walletmaster-detail-badge ${selectedTransaction.transactionType === 'CREDIT' ? 'walletmaster-badge-credit' : 'walletmaster-badge-debit'}`}>
                    {selectedTransaction.transactionType}
                  </span>
                </div>
                <div className="walletmaster-detail-item">
                  <span className="walletmaster-detail-label">Amount:</span>
                  <span className={`walletmaster-detail-amount ${selectedTransaction.transactionType === 'CREDIT' ? 'walletmaster-credit-text' : 'walletmaster-debit-text'}`}>
                    {selectedTransaction.transactionType === 'CREDIT' ? '+' : '-'}₹{selectedTransaction.amount}
                  </span>
                </div>
                <div className="walletmaster-detail-item">
                  <span className="walletmaster-detail-label">Balance Type:</span>
                  <span className="walletmaster-detail-value">{selectedTransaction.balanceType}</span>
                </div>
                <div className="walletmaster-detail-item">
                  <span className="walletmaster-detail-label">Date:</span>
                  <span className="walletmaster-detail-value">
                    <FaCalendarAlt /> {formatDate(selectedTransaction.transactionTime)}
                  </span>
                </div>
                <div className="walletmaster-detail-item">
                  <span className="walletmaster-detail-label">Time:</span>
                  <span className="walletmaster-detail-value">
                    <FaClock /> {formatTime(selectedTransaction.transactionTime)}
                  </span>
                </div>
                <div className="walletmaster-description">
                  <h4>Description</h4>
                  <p>
                    This {selectedTransaction.transactionType.toLowerCase()} transaction was successfully processed.
                  </p>
                </div>
              </div>
              <div className="walletmaster-modal-footer">
                <button className="walletmaster-close-btn" onClick={closeModal}>
                  Close
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Payment;

